import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { TopNavbarStyled } from '../TopNavbarStyled';
import { rem } from 'polished';

export const TopNavbarStyledOV = styled(TopNavbarStyled)`
    background: ${(p) => p.theme.colors.grey20};
    border: none;

    @media (max-width: ${breakpoints.xs}px) {
        margin-left: 10px;
        margin-top: 10px;
        border-bottom: none;
    }

    .topnavbar-grid {
        padding: 0;
        width: 100vw;
        @media (max-width: ${breakpoints.xs}px) {
            grid-template-columns: 1fr 8fr 1fr;
        }
        @media (min-width: ${breakpoints.xs}px) {
            width: 100%;
            padding: 0 10px;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        position: relative;

        &-title {
            text-transform: uppercase;
            font-size: ${rem('21px')};
            line-height: ${rem('23px')};
            font-weight: ${(p) => p.theme.fontWeights.textRegular};
            color: ${(p) => p.theme.colors.black2};

            @media (max-width: ${breakpoints.xs}px) {
                font-size: ${(p) => p.theme.fontSizes.h4};
                line-height: ${(p) => p.theme.lineHeights.h4};
            }
        }

        &-step {
            font-weight: 700;
        }
    }

    .topnavbar-returnlink {
        cursor: pointer;
        color: ${(p) => p.theme.colors.black2};
        font-weight: ${(p) => p.theme.fontWeights.textMedium};
        text-transform: uppercase;
        font-size: ${(p) => p.theme.fontSizes.textBase};
        border: none;
        display: flex;
        align-items: baseline;
        min-width: ${rem('80px')};
        padding: 0.6rem 1rem;

        &__text {
            display: none;

            @media (min-width: ${breakpoints.xs}px) {
                display: inline-block;
                font-family: ${(p) => p.theme.fonts.fontBase};
            }
        }

        :not(.isDisabled),
        :not(:disabled) {
            &:hover,
            &:focus-visible {
                background-color: ${(p) => p.theme.colors.primary};
                border-color: ${(p) => p.theme.colors.primary};
                color: ${(p) => p.theme.colors.black2};

                svg {
                    path {
                        stroke: ${(p) => p.theme.colors.black2};
                    }
                }

                @media (max-width: ${breakpoints.xs}px) {
                    background: none;

                    .icon-wrapper {
                        svg {
                            path {
                                stroke: ${(p) => p.theme.colors.black2};
                            }
                        }
                    }
                }
            }
        }

        .icon-wrapper {
            width: ${rem('13px')};
            height: auto;

            @media (min-width: ${breakpoints.xs}px) {
                width: ${rem('13px')};
                margin-right: ${rem('8px')};
            }
        }

        svg {
            height: ${rem('36px')};
            width: ${rem('30px')};

            @media (min-width: ${breakpoints.xs}px) {
                height: ${rem('6px')};
                width: ${rem('13px')};
                margin: 0 0 ${rem('2px')} 0;
                path {
                    stroke: ${(p) => p.theme.colors.grey5};
                }
            }
        }

        &__hidden {
            @media (max-width: ${breakpoints.xs}px) {
                color: ${({ theme }) => theme.colors.black2};

                .icon-wrapper {
                    height: 0 !important;

                    svg {
                        path {
                            stroke: ${(p) => p.theme.colors.black2};
                        }
                    }
                }
            }
        }

        @media (max-width: ${breakpoints.xs}px) {
            color: ${({ theme }) => theme.colors.black2};
            border: none;

            .icon-wrapper {
                height: 0 !important;

                svg {
                    height: ${rem('18px')};
                    width: ${rem('18px')};

                    path {
                        stroke: ${(p) => p.theme.colors.black2};
                    }
                }
            }
        }
    }

    .save-button {
        border-color: ${(p) => p.theme.colors.primaryBlack};
        color: ${(p) => p.theme.colors.primaryBlack};
        font-family: ${(p) => p.theme.fonts.fontBase};
        font-size: ${rem('14px')};
        padding-right: ${rem('34px')};
        padding-left: ${rem('34px')};

        &:hover:enabled,
        &:focus-visible:enabled {
            color: ${(p) => p.theme.colors.primaryBlack};
        }
    }

    .Select {
        &__control {
            border: none;
        }

        &__indicators {
            padding: 4px;

            @media (min-width: ${breakpoints.sm}px) {
                padding: 5px;
            }

            @media (min-width: ${breakpoints.md}px) {
                padding: 8px;
            }
        }
    }
`;
